import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../images/Logo.png';
import GrantPhoto from '../images/grant2.jpg';
import '../styles/template.css';

const ElevatePage = () => {

  const handlePurchase = () => {
    window.location.href = 'https://7de6-grant.systeme.io/98063388';
  };

  return (
    <div className="container">
      <header>
        <div className="logo-container">
          <img src={Logo} alt="Logo" className="logo" />
        </div>
        <h1>Elevate</h1>
        <nav>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/partners">Partners</Link></li>
            <li><Link to="/elevate">Elevate</Link></li>
            <li><Link to="/connect">Connect</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </nav>
      </header>

      <main>
        <h2 className="main-heading">Elevate Your Potential</h2>

        <section className="partners-intro">
          <p style={{ fontSize: '17px', lineHeight: '1.7', maxWidth: '800px', margin: '0 auto' }}>
            Transform your thinking patterns and unlock the mindset that separates achievers from dreamers.
            "Develop a Winning Mindset" gives you strategies for success in a competitive world.
          </p>
        </section>

        <section className="partners-grid">
          <div className="partner-category">
            <h3 style={{ textAlign: 'center', borderBottom: 'none', paddingBottom: '0' }}>Meet Your Instructor</h3>
            <div style={{ textAlign: 'center', maxWidth: '700px', margin: '0 auto' }}>
              <div style={{ marginBottom: '24px' }}>
                <img
                  src={GrantPhoto}
                  alt="Grant Reynolds"
                  style={{
                    width: '100%',
                    maxWidth: '300px',
                    height: 'auto',
                    borderRadius: '16px',
                    border: '4px solid #2b6cb0',
                    boxShadow: '0 12px 40px rgba(43, 108, 176, 0.2)',
                    display: 'block',
                    margin: '0 auto'
                  }}
                />
              </div>
              <h4 style={{ fontSize: '26px', marginBottom: '12px', color: '#1a365d', fontWeight: '700' }}>Grant Reynolds</h4>
              <p style={{ fontSize: '16px', color: '#4a5568', marginBottom: '20px', fontWeight: '600' }}>
                Air Force Veteran | Martial Artist | CEO/Founder Know Yourself LLC
              </p>
              <p style={{ fontSize: '16px', lineHeight: '1.8', maxWidth: '650px', margin: '0 auto', color: '#4a5568', textAlign: 'left' }}>
                Grant brings a unique perspective to mindset development, combining military discipline,
                martial arts philosophy, and real-world business experience. As a technology professional
                and entrepreneur, he understands the mental challenges of building something from nothing
                and the mindset shifts required to achieve lasting success.
              </p>
            </div>
          </div>

          <div className="partner-category">
            <h3>The Course</h3>
            <div className="partner-cards">
              <div className="partner-card featured-partner" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '24px' }}>
                <div style={{
                  width: '120px',
                  height: '120px',
                  background: 'linear-gradient(135deg, #2b6cb0 0%, #1a365d 100%)',
                  borderRadius: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '48px',
                  boxShadow: '0 8px 24px rgba(43, 108, 176, 0.3)'
                }}>
                  <span role="img" aria-label="brain">&#x1F9E0;</span>
                </div>
                <div className="partner-info" style={{ textAlign: 'center' }}>
                  <h4 style={{ fontSize: '22px', color: '#1a365d' }}>Develop a Winning Mindset</h4>
                  <p style={{ fontSize: '16px', lineHeight: '1.7', textAlign: 'center', maxWidth: '600px', margin: '0 auto 20px' }}>
                    Master the mental strategies that drive success in business and life. This comprehensive video course
                    teaches you how to overcome limiting beliefs, build unshakeable confidence, and develop the resilience
                    needed to achieve your most ambitious goals.
                  </p>

                  <div className="partner-credentials" style={{ marginTop: '20px', textAlign: 'left' }}>
                    <strong style={{ color: '#1a365d' }}>What You'll Get:</strong>
                    <ul style={{ marginTop: '12px', paddingLeft: '20px', lineHeight: '2' }}>
                      <li>High-quality video modules</li>
                      <li>Mobile & desktop streaming</li>
                      <li>Access to exclusive community (coming soon)</li>
                    </ul>
                  </div>

                  <div style={{ marginTop: '28px', display: 'flex', gap: '16px', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <div style={{
                      background: '#38a169',
                      color: 'white',
                      padding: '12px 24px',
                      borderRadius: '8px',
                      fontWeight: '700',
                      fontSize: '20px',
                      boxShadow: '0 4px 12px rgba(56, 161, 105, 0.3)'
                    }}>
                      $79
                    </div>
                    <button
                      onClick={handlePurchase}
                      className="cta-button"
                      style={{ margin: '0', fontSize: '16px' }}
                    >
                      Get Instant Access
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="partner-category">
            <h3>What You'll Learn</h3>
            <div className="partner-cards">
              <div className="partner-card">
                <div className="partner-info">
                  <h4>Mental Discipline & Focus</h4>
                  <p>Learn techniques for developing laser-sharp focus and mental discipline that cuts through distraction and doubt.</p>
                </div>
              </div>
              <div className="partner-card">
                <div className="partner-info">
                  <h4>Resilience & Adaptability</h4>
                  <p>Master mental toughness, turning setbacks into comebacks, and maintaining composure under pressure.</p>
                </div>
              </div>
              <div className="partner-card">
                <div className="partner-info">
                  <h4>Entrepreneurial Mindset</h4>
                  <p>Develop the thinking patterns and decision-making frameworks used by successful business leaders and entrepreneurs.</p>
                </div>
              </div>
              <div className="partner-card">
                <div className="partner-info">
                  <h4>Psychology of Success</h4>
                  <p>Understand the science behind peak performance and how to rewire your brain for sustained achievement and growth.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section style={{
          padding: '48px 32px',
          background: 'linear-gradient(135deg, #1a365d 0%, #2b6cb0 100%)',
          margin: '40px 0',
          borderRadius: '16px',
          color: 'white',
          textAlign: 'center'
        }}>
          <h3 style={{ fontSize: '28px', marginBottom: '20px', fontWeight: '700', color: 'white', borderBottom: 'none', paddingBottom: '0' }}>Coming Soon: Elevate Society</h3>
          <p style={{ fontSize: '17px', lineHeight: '1.7', maxWidth: '800px', margin: '0 auto 32px', color: 'rgba(255,255,255,0.9)' }}>
            Join an exclusive community of entrepreneurs, creators, and professionals committed to self-actualization and peak performance.
            Get access to expert-led courses, live mentorship, and a supportive Discord community that accelerates your growth.
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '20px',
            maxWidth: '900px',
            margin: '0 auto',
            textAlign: 'left'
          }}>
            <div style={{ background: 'rgba(255,255,255,0.1)', padding: '24px', borderRadius: '12px' }}>
              <h4 style={{ fontSize: '18px', marginBottom: '8px', color: 'white' }}>Expert-Led Courses</h4>
              <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'rgba(255,255,255,0.85)', marginBottom: '0' }}>Access premium courses from industry professionals, with templates and structured learning paths designed for real-world application.</p>
            </div>
            <div style={{ background: 'rgba(255,255,255,0.1)', padding: '24px', borderRadius: '12px' }}>
              <h4 style={{ fontSize: '18px', marginBottom: '8px', color: 'white' }}>Exclusive Community</h4>
              <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'rgba(255,255,255,0.85)', marginBottom: '0' }}>Connect with like-minded individuals in our private Discord, featuring topic-based discussions, live Q&As, and peer mentorship.</p>
            </div>
            <div style={{ background: 'rgba(255,255,255,0.1)', padding: '24px', borderRadius: '12px' }}>
              <h4 style={{ fontSize: '18px', marginBottom: '8px', color: 'white' }}>Personal Guidance</h4>
              <p style={{ fontSize: '15px', lineHeight: '1.6', color: 'rgba(255,255,255,0.85)', marginBottom: '0' }}>Work with dedicated counselors who help you choose the right courses and create a personalized growth path based on your goals.</p>
            </div>
          </div>

          <p style={{ fontSize: '16px', marginTop: '28px', color: 'rgba(255,255,255,0.8)' }}>
            Be the first to know when Elevate Society launches -
            <strong style={{ textDecoration: 'underline', color: 'white' }}> premium community access starting soon!</strong>
          </p>
        </section>

        <section className="partnership-cta">
          <h3 style={{ fontSize: '26px' }}>Ready to Transform Your Mindset?</h3>
          <p style={{ fontSize: '17px', lineHeight: '1.7', maxWidth: '700px', margin: '0 auto 28px' }}>
            Start your journey with our flagship course, and get early access to Elevate Society when it launches.
            Combine military discipline, martial arts philosophy, and entrepreneurial strategy
            to develop the unshakeable mindset that drives lasting success.
          </p>

          <button
            onClick={handlePurchase}
            className="cta-button"
            style={{
              background: 'linear-gradient(135deg, #38a169 0%, #2f855a 100%)',
              padding: '18px 40px',
              fontSize: '18px',
              boxShadow: '0 8px 24px rgba(56, 161, 105, 0.3)'
            }}
          >
            Get Instant Access - $79
          </button>

          <div style={{ marginTop: '24px', fontSize: '14px', color: '#718096' }}>
            <p>Instant access after purchase | Lifetime access | Mobile & desktop compatible</p>
          </div>
        </section>
      </main>

      <footer>
        <p>&copy; 2026 Know Yourself LLC | All rights reserved.</p>
      </footer>
    </div>
  );
};

export default ElevatePage;
